import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { SidenavService } from 'src/app/modules/shared/services/sidenav.service';
import { AddItemProjectDialogComponent } from '../add-item-project-dialog/add-item-project-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GenericDialogComponent } from 'src/app/modules/shared/generic-dialog/generic-dialog.component';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TecnologiasService } from 'src/app/modules/shared/services/tecnologias.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { AssociateEstimatesDialogComponent } from '../associate-estimates-dialog/associate-estimates-dialog.component';
import { EditInitialCostDialogComponent } from '../edit-initial-cost-dialog/edit-initial-cost-dialog.component';
import { ResultDataService } from 'src/app/modules/shared/services/resultcombined-data.service';
import { catchError, delay, retryWhen, scan } from 'rxjs/operators';
import { forkJoin, throwError } from 'rxjs';
import { ScrollControlService } from 'src/app/modules/shared/services/scroll-control.service';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { InfoBarWithStatusService } from 'src/app/modules/shared/services/info-bar-with-status.service';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { RemoveDialogComponent } from 'src/app/modules/backoffice/remove-dialog/remove-dialog.component';
import { EstimationState } from 'src/app/models/EstimationState';
import { Permission } from 'src/app/modules/shared/security/permission';
import { ProfileService } from 'src/app/modules/shared/services/profile.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';


@Component({
  standalone: false,
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css'],
  animations: [
    trigger('slideToggle', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
})

export class ProjectComponent implements OnInit, AfterViewInit {
  variables: any;
  arr1: any = [];

  isOpen: boolean = false;
  dataSource = new MatTableDataSource();
  sortedData: any[] = [];
  associatedFolders: any[] = [];
  notAssociatedEstimates = new MatTableDataSource<any>([]);
  associatedEstimates: any[] = [];
  dataSourceUsers = new MatTableDataSource();
  // displayedColumns: string[] = ['select', 'ID', 'name', 'method', 'createdDate', 'lastModifiedDate'];
  displayedColumns = ['select', 'ID', 'name', 'catalog', 'data_i', 'data_f', 'method', 'state', 'actions'];
  displayedColumns1: string[] = ['name', 'mail', 'actions'];
  displayedColumnsAssociated: string[] = ['ID', 'name', 'method', 'data_i', 'data_f', 'actions'];
  project: any;
  userName: any;
  shouldPinSidenav: boolean = false;
  openManageTable: boolean = false;
  selectedSectionIndex: number = 0;

  usersList: any = []; //users list to update BD
  allUsers: any[] = []; //List of all users in the system.

  selectedEstimates: boolean = false;
  showSave: boolean = false;

  selection: any = new SelectionModel(true);
  selectedMethod = '';

  colorBlue = '#0596FF';
  colorWhite = '#fff';
  // this.variables.invalidEstimateByMethod

  isLoading: boolean = true;
  isLoadingEstimates: boolean = true;

  errorDetected: boolean = false;
  errorText: string = '';

  financialSummary = { initialCost: 0, upgrades: 0, baseline: 0, maintenance: 0 };
  initialCostIsManual: boolean = false;


  combineResultData: any = {
    estimates: null,
    name: ''
  };

  associationResult: any;

  errorMessages: any;

  associationEstimates: any;

  userId: any;

  EstimationState = EstimationState;

  @ViewChild(MatSort) sort: any;

  @ViewChild('paginator1') paginator1!: MatPaginator;
  @ViewChild('paginator2') paginator2!: MatPaginator;


  Permission = Permission

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: DataService,
    public authService: AuthService,
    private sidenavService: SidenavService,
    private languageService: LanguageService,
    private projectService: ProjectsService,
    private estimateService: ApiEstimativaService,
    public dialog: MatDialog,
    private infoBar: InfoBarWithStatusService,
    private tecnologiasService: TecnologiasService,
    private usersManagementService: UsersManagementService,
    private resultDataService: ResultDataService,
    private cdr: ChangeDetectorRef,
    private scrollService: ScrollControlService,
    private location: Location,
    private profileService: ProfileService,
  ) { }


  public estimationState = EstimationState;

  ngOnInit(): void {
    this.scrollService.setScroll(false);

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.authService.getUserData().subscribe(user => {
      if (user) {
        this.userId = user.id;
      }
    });

    this.service.setEstimate({});;
    if (!this.service.getProject()) {
      this.router.navigate(['/projectos']);
    }
    else {
      this.getProjectById(this.service.getProject()!);
    }

    this.errorMessages = {
      'Invalid JWT token': this.variables.sessionExpired,
      "Forbidden to search users": this.variables.unauthorizedToSearchUsers,
      'Forbidden to remove user': this.variables.forbidenRemoveUsers,
      'Project not found': this.variables.project + this.variables.notFound,
      'Only current owner can remove users': this.variables.onlyCurrentOwnerCanRemoveUsers,
      'No user found with the specified email in the project': this.variables.EmailNotFoundInProject,
    };
  }

  goBack() {
    this.router.navigate(['/projectos']);
  }

  getProjectById(id: string) {
    this.isLoading = true;

    this.projectService.getProjectById(id).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.project = data;
          if (this.project.users) {
            setTimeout(() => {
              this.dataSourceUsers.data = this.project.users;
              this.dataSourceUsers.paginator = this.paginator2;
            });
          } else {
            this.dataSourceUsers.data = [];
          }
          this.getEstimatesProject(id);
          this.cdr.detectChanges();
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.project) {
          this.isLoading = false;
        }
      }
    });
  }

  getEstimatesProject(id: string) {
    this.isLoadingEstimates = true;

    this.estimateService.getProjectEstimates(id).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.notAssociatedEstimates.data = data.filter(item => item.associatedName == null)


          console.log(this.notAssociatedEstimates.data);
          setTimeout(() => {
            this.notAssociatedEstimates.paginator = this.paginator1;
            this.notAssociatedEstimates.sort = this.sort;
          });

          data.forEach((item: any) => {

            if (item.associatedName) {
              const existingFolder = this.associatedFolders.find(
                folder => folder.name === item.associatedName
              );

              if (existingFolder) {
                existingFolder.estimates.push(item);
              }
              else {
                this.associatedFolders.push({
                  name: item.associatedName,
                  estimates: [item],
                  isVisible: false
                });
              }
            }
          });

          this.computeFinancialSummary(data);
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (!this.errorDetected) {
          this.isLoadingEstimates = false;
        }
      }
    });
  }

  private computeFinancialSummary(estimates: any[]): void {
    const closedEstimates = estimates.filter(e => e.state === EstimationState.CLOSED);

    if (closedEstimates.length === 0) {
      this.applyFinancialTotals(0);
      return;
    }

    // Fetch profiles once, then fetch full estimate + calculate for each closed estimate
    this.profileService.getAllProfiles().pipe(
      switchMap(profiles => {
        // Sort profiles ascending by cost — matches result.component.ts behaviour
        const sortedProfiles = [...profiles].sort((a: any, b: any) => a.costPerHour - b.costPerHour);

        const requests = closedEstimates.map(e =>
          this.estimateService.getEstimateById(e.id).pipe(
            switchMap(fullEstimate => {
              // Replicate result.component.ts rebuildProfileSnapshotsFromEstimate():
              // Only keep profiles that are actually assigned to items, sorted by costPerHour
              const usedProfileIds = new Set<string>();
              (fullEstimate.configurations || []).forEach((c: any) => { if (c.profileId) usedProfileIds.add(c.profileId); });
              (fullEstimate.parameters || []).forEach((p: any) => { if (p.profileId) usedProfileIds.add(p.profileId); });
              (fullEstimate.macroActivities || []).forEach((macro: any) => {
                (macro?.macroActivities || []).forEach((ma: any) => { if (ma.profileId) usedProfileIds.add(ma.profileId); });
              });
              (fullEstimate.subTasks || []).forEach((st: any) => { if (st.profileId) usedProfileIds.add(st.profileId); });

              fullEstimate.profileSnapshots = Array.from(usedProfileIds)
                .map(pid => {
                  const profile = sortedProfiles.find((p: any) => p.id === pid);
                  return profile ? { profileId: profile.id, profileName: profile.name, costPerHour: profile.costPerHour || 0 } : null;
                })
                .filter((s: any) => s !== null)
                .sort((a: any, b: any) => a.costPerHour - b.costPerHour);

              return this.estimateService.calculateEst(fullEstimate).pipe(
                switchMap(result => of({ estimate: fullEstimate, result }))
              );
            })
          )
        );
        return forkJoin(requests);
      })
    ).subscribe({
      next: (pairs: any[]) => {
        const upgrades = pairs.reduce((sum, { estimate, result }) => {
          return sum + this.computeSingleEstimateCost(estimate, result);
        }, 0);
        this.applyFinancialTotals(upgrades);
      },
      error: () => {
        // If cost calculation fails, fall back to showing 0
        this.applyFinancialTotals(0);
      }
    });
  }

  private computeSingleEstimateCost(estimate: any, result: any): number {
    const getCost = (profileId: string | null, hours: number): number => {
      if (!profileId || !Array.isArray(estimate.profileSnapshots)) return 0;
      const snap = estimate.profileSnapshots.find((ps: any) => ps.profileId === profileId);
      return snap?.costPerHour ? hours * snap.costPerHour : 0;
    };

    let total = 0;
    let totalHours = 0;

    (result.configurations ?? []).forEach((item: any, i: number) => {
      total += getCost(estimate.configurations?.[i]?.profileId ?? null, item.complexity);
      totalHours += item.complexity;
    });

    (result.parameters ?? []).forEach((item: any, i: number) => {
      total += getCost(estimate.parameters?.[i]?.profileId ?? null, item.complexity);
      totalHours += item.complexity;
    });

    let macroIndex = 0;
    (result.macroActivities ?? []).forEach((macro: any) => {
      (macro.macroActivityResults ?? []).forEach((macroResult: any) => {
        const estimateMacro = estimate.macroActivities?.[macroIndex];
        const profileId = estimateMacro?.macroActivities?.find(
          (ma: any) => ma.name === macroResult.name
        )?.profileId ?? null;
        total += getCost(profileId, macroResult.complexity);
        totalHours += macroResult.complexity;
      });
      macroIndex++;
    });

    (result.subTasks ?? []).forEach((item: any, i: number) => {
      total += getCost(estimate.subTasks?.[i]?.profileId ?? null, item.complexity);
      totalHours += item.complexity;
    });

    (result.productivityTools ?? []).forEach((tool: any) => {
      const task = (result.subTasks ?? []).find(
        (t: any) => t.task === tool.task && t.subTask === tool.subTask
      );
      const profileId = task?.profileId ?? null;
      const snap = Array.isArray(estimate.profileSnapshots)
        ? estimate.profileSnapshots.find((ps: any) => ps.profileId === profileId)
        : null;
      total -= tool.gains * (snap?.costPerHour ?? 0);
      totalHours -= tool.gains;
    });

    // Add risk cost: (risk% × totalHours) × profileSnapshots[0].costPerHour
    // This matches result.component.ts finalCostEuros formula (slider at position 0)
    const riskPct = estimate.projectType?.risk ?? 0;
    const riskProfileCost = Array.isArray(estimate.profileSnapshots) && estimate.profileSnapshots.length > 0
      ? (estimate.profileSnapshots[0].costPerHour ?? 0)
      : 0;
    total += (riskPct / 100) * totalHours * riskProfileCost;

    return total;
  }

  private applyFinancialTotals(upgrades: number): void {
    const initialCost = this.project.initialCost ?? 0;
    this.initialCostIsManual = this.project.initialCost == null;
    const baseline = initialCost + upgrades;
    const maintenance = baseline * ((this.project.maintenancePct ?? 0) / 100);
    this.financialSummary = { initialCost, upgrades, baseline, maintenance };
  }

  openEditInitialCostDialog(): void {
    const dialogRef = this.dialog.open(EditInitialCostDialogComponent, {
      data: { currentValue: this.project.initialCost ?? 0 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;

      this.projectService.updateInitialCost(this.project.id, result.value).subscribe({
        next: () => {
          this.project.initialCost = result.value;
          this.applyFinancialTotals(this.financialSummary.upgrades);
          this.infoBar.showSnackbar(this.variables.successfullyEditedProject, ['successful-snackbar'], 2000);
        },
        error: () => {
          this.infoBar.showSnackbar(this.variables.detectedError, ['error-snackbar'], 2000);
        }
      });
    });
  }

  getUpdatedEstimatesProject(id: string) {
    this.isLoadingEstimates = true;

    this.estimateService.getProjectEstimates(id).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {

        try {
          this.notAssociatedEstimates.data = data.filter(item => item.associatedName == null)

          setTimeout(() => {
            this.notAssociatedEstimates.paginator = this.paginator1;
            this.notAssociatedEstimates.sort = this.sort;
          });
          data.forEach((item: any) => {

            if (item.associatedName) {
              const existingFolder = this.associatedFolders.find(
                folder => folder.name === item.associatedName
              );

              if (!this.containsEstimateName(this.associatedFolders, item.idEstimate)) {
                if (existingFolder) {
                  existingFolder.estimates.push(item);
                }
                else {
                  this.associatedFolders.push({
                    name: item.associatedName,
                    estimates: [item],
                    isVisible: false
                  });
                }

              }
            }
          });
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (!this.errorDetected) {
          this.isLoadingEstimates = false;
        }
      }
    });
  }

  containsEstimateName(data: any, idEstimate: String) {
    return Object.values(data).some((entry: any) =>
      Array.isArray(entry.estimates) &&
      entry.estimates.some((estimate: any) => estimate.idEstimate === idEstimate)
    );
  }

  associateEstimate(estimateIds: string[], folderName: string) {
    this.isLoadingEstimates = true;

    this.estimateService.associateEstimate(estimateIds, folderName).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          if (data.success) {

            this.getUpdatedEstimatesProject(this.service.getProject()!);
          }

        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (!this.errorDetected) {
          this.isLoadingEstimates = false;
        }
      }
    });
  }

  removeAssociationEstimate(estimateId: string) {
    this.isLoadingEstimates = true;

    this.estimateService.removerAssociationEstimate(estimateId).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          if (data.success) {
            this.associatedFolders = [];
            this.getEstimatesProject(this.service.getProject()!);

            this.infoBar.showSnackbar(this.variables.estimateRemovedAssociationSuccessfully, ['successful-snackbar'], 2000);
          }

        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (!this.errorDetected) {
          this.isLoadingEstimates = false;
        }
      }
    });
  }

  getAssociationresult(estimates: any[], estimateIds: string[], folderName: string) {
    this.isLoadingEstimates = true;

    this.estimateService.getAssociationResult(estimateIds).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        this.associationEstimates = estimates

        console.log(estimates);
        console.log(data);
        console.log(this.project);

        try {
        if (data) {

            const parentData = {
              resultEstimates: data,
              name: folderName,
              project: this.project.name,
              projectMetodology: estimates[0].projectMetodology,
              estimateMode: estimates[0].estimateMode
            };

            this.resultDataService.setParentData(parentData);
            this.resultDataService.setAssociatedEstimatesData(this.associationEstimates);

            this.router.navigate(['/projecto/result']);
          }

        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (!this.errorDetected) {
          this.isLoadingEstimates = false;
        }
      }
    });
  }

  hasIncompleteEstimate(estimates: any[]): boolean {
    for (const estimate of estimates) {
      if (estimate.state && estimate.state === this.estimationState.INCOMPLETE) {
        return true;
      }
    }
    return false;
  }

  hasDifferentMethodology(event: Event) {
    event.stopPropagation()

    setTimeout(() => {
      if (this.selection.selected.length > 0) {
        this.selectedMethod = this.selection.selected[0].estimateMode
      }
      else {
        this.selectedMethod = ''
      }
    });
  }

  associationDisabledCodition(rowState: string, rowEstimateMode: string) {
    return rowState === this.estimationState.INCOMPLETE || (this.selectedMethod !== '' && rowEstimateMode !== this.selectedMethod)
  }

  associationDisabledMessage(rowState: string, rowEstimateMode: string) {
    if (rowState === this.estimationState.INCOMPLETE) {
      return this.variables.tooltipOngoingEstimate;
    }
    else if ((this.selectedMethod !== '' && rowEstimateMode !== this.selectedMethod)) {
      return this.variables.invalidEstimateByMethod;
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.selection.selected.length > 0) {
      this.selectedEstimates = true;
    }
    else {
      this.selectedEstimates = false;
      return false
    }
    const numSelected = this.selection.selected.length;
    const numRows = this.notAssociatedEstimates.data.filter(element => element.estimateMode === this.selectedMethod).length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ? this.masterToggleClear() : this.masterToggleFill()
  }

  masterToggleClear() {
    this.selectedMethod = ''
    this.selection.clear()
  }

  masterToggleFill() {

    if (this.selectedMethod === '') {
      this.selectedMethod = this.notAssociatedEstimates.data.find(element => element.state !== this.estimationState.INCOMPLETE).estimateMode
    }

    this.notAssociatedEstimates.data.forEach(row => {
      if (row.state !== this.estimationState.INCOMPLETE && row.estimateMode === this.selectedMethod) {

        this.selection.select(row)
      }
    });
  }




  ngAfterViewInit(): void {
    this.selectedEstimates = this.isAllSelected();
    this.dataSourceUsers.paginator = this.paginator2;
    this.dataSourceUsers.sort = this.sort;

    this.dataSource.sort = this.sort;
    this.notAssociatedEstimates.paginator = this.paginator1;
  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  goTo(name: string, element: string) {
    if (name == 'estimativa') {
      localStorage.setItem("projName", element);
      this.service.setEstimativaNavigationContext({ origin: "projectPage" });
      this.router.navigate(['/' + name]);
    }
    else {
      this.router.navigate(['/' + name]);
    }
  }

  checkEstimate(element: any) {

    if (this.canCheckEstimate(element)) {
      this.service.setEstimativaNavigationContext({ origin: "combinedResultPage" });
      this.service.setEstimate(element);
      this.router.navigate(['/estimativa/resultado']);
    }
    else {
      this.tecnologiasService.getUserTechnologies().subscribe((data: any) => {

        if (this.project.isActive == false && !data.find((item: any) => { return item.name == element.catalog })) {
          this.infoBar.showSnackbar(this.variables.snackBarMessageAllInactive, ['error-snackbar'], 4000);
        }
        else if (this.project.isActive == false) {
          this.infoBar.showSnackbar(this.variables.snackBarMessageProjInactive, ['error-snackbar'], 4000);
        }
        else if (!data.find((item: any) => { return item.name == element.catalog })) {
          this.infoBar.showSnackbar(this.variables.snackBarMessageCatalogInactive, ['error-snackbar'], 4000);
        }

      })
    }

  }

  associateEstimates() {
    let folderNames: any = [];

    this.associatedFolders.forEach((folder: any) => {
      folderNames.push(folder.name);
    })

    const data = {
      title: this.variables.groupEstimates,
      estimates: this.selection.selected,
      associatedNames: folderNames
    }

    let dialogRef = this.dialog.open(AssociateEstimatesDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        const folderExists = result.data.associatedNames.includes(result.data.name);
        let selectedFolderIndex = this.associatedFolders.findIndex((folder: any) => folder.name === result.data.name)
        let selectedFolder = this.associatedFolders[selectedFolderIndex];

        if (folderExists) {

          if (this.selectedMethod !== selectedFolder.estimates[0].estimateMode) {
            this.infoBar.showSnackbar(this.variables.invalidFolderForEstimateByMethod, ['error-snackbar'], 2000);
            this.masterToggleClear()
            return;
          }
        }

        const estimatesId: string[] = result.data.estimates.map((estimate: any) => estimate.id);
        this.associateEstimate(estimatesId, result.data.name);

        if (folderExists && selectedFolder) {
          selectedFolder.estimates = [...selectedFolder.estimates, ...result.data.estimates];
        }

        if (folderExists) {
          this.infoBar.showSnackbar(this.variables.estimateAddedAssociationSuccessfully, ['successful-snackbar'], 2000);
        }
        else {
          this.infoBar.showSnackbar(this.variables.associationCreatedSuccessfully, ['successful-snackbar'], 2000);
        }

        this.masterToggleClear();

      }

    })

  }

  removeEstimate(estimate: any) {

    this.removeAssociationEstimate(estimate.id);
  }

  openManageUsersTable() {

    this.openManageTable = !this.openManageTable;
    this.selectedSectionIndex = this.openManageTable ? 1 : 0;

    if (this.openManageTable) {
      setTimeout(() => {
        this.dataSourceUsers.sort = this.sort;
        this.dataSourceUsers.paginator = this.paginator2;
      });

    }
    else {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator1;
    }
    this.cdr.detectChanges();
  }

  onSectionChange(index: number) {
    this.selectedSectionIndex = index;
    this.openManageTable = index === 1;

    if (this.openManageTable) {
      setTimeout(() => {
        this.dataSourceUsers.sort = this.sort;
        this.dataSourceUsers.paginator = this.paginator2;
      });
    } else {
      setTimeout(() => {
        this.notAssociatedEstimates.paginator = this.paginator1;
        this.notAssociatedEstimates.sort = this.sort;
      });
    }

    this.cdr.detectChanges();
  }

  fetchUserFromSystem() {
    this.usersManagementService.getAllUsers().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data) => {
        data.forEach((user: any) => {
          this.allUsers.push({ 'id': user.id, 'name': user.name + " " + user.lastName, 'email': user.email });
        })
      },
      complete: () => {
        this.isLoading = false
        var usersInProject: any = [];
        usersInProject = this.dataSourceUsers.data;

        const data = {
          title: this.variables.addUserToProject,
          isAddUser: true,
          projectId: this.project.id,
          allUsers: this.allUsers,
          usersInProject: usersInProject
        }

        let dialogRef = this.dialog.open(AddItemProjectDialogComponent, {
          data: data
        });

        dialogRef.afterClosed().subscribe
          ({
            next: (data) => {
              if (data.data.success) {
                this.isLoading = true;
                this.infoBar.showSnackbar(this.variables.successfullyAddedUser, ['successful-snackbar'], 3000);
                this.getProjectById(this.project.id);
              }
            },
            error: (error) => {

              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
            }
          });
      }
    });
  }


  openDialogAddUser() {
    // Prepare data to be passed to dialog component
    this.fetchUserFromSystem()

  }

  removeUser(name: string, email: string) {
    const data = {
      message: this.variables.removeUserProject
    }
    //Open dialog
    let dialogRef = this.dialog.open(GenericDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.data) {
        this.projectService.removeUserFromProject(this.project.id, name, email).subscribe
          ({
            next: (data) => {

              if (data) {
                this.infoBar.showSnackbar(this.variables.successfullyRemovedUser, ['successful-snackbar'], 2000);
                this.getProjectById(this.project.id);
              }
            },
            error: (error) => {

              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
            }
          })
      }
    }
    );
  }


  saveUsers() {

    let project = {
      id: this.project.id,
      name: this.project.name,
      wbscode: this.project.wbscode,
      isActive: this.project.isActive,
      estimates: this.project.estimates,
      createdDate: this.project.createdDate,
      lastModifiedDate: this.project.lastModifiedDate,
      users: this.dataSourceUsers.data,
      projectOwner: this.project.projectOwner
    }
    this.projectService.updateProject(project);
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'ID':
          return this.compare(a.idEstimate, b.idEstimate, isAsc);
        case this.variables.name:
          return this.compare(a.name, b.name, isAsc);
        case this.variables.createdDate:
          return this.compare(a.createdDate, b.createdDate, isAsc);
        case this.variables.lastModifiedDate:
          return this.compare(a.lastModifiedDate, b.lastModifiedDate, isAsc);
        default:
          return 0;
      }
    })
  }

  saveEstimates() {

    let folderData: any = [];
    this.associatedFolders.forEach((folder: any) => {
      folderData.push(...folder.estimates);
    });
    folderData.push(...this.notAssociatedEstimates.data);
    this.projectService.updateProjectEstimates(folderData).subscribe();
    this.router.navigate(['/dashboard']);
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a > b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  toggleDivVisibility(name: string) {
    const i = this.associatedFolders.findIndex((folder: any) => folder.name == name);
    if (this.associatedFolders[i].isVisible == true) {
      this.associatedFolders[i].isVisible = false;
    }
    else {
      this.associatedFolders[i].isVisible = true;
    }
  }

  combinatedResult(estimates: any[], folderName: string): void {
    const requests = estimates.map(estimate => estimate.id);
    const associatedEstimateDTOs = estimates.map(estimate =>
      this.estimateService.getEstimateById(estimate.id)
    );

    forkJoin(associatedEstimateDTOs).subscribe(
      (responses: any[]) => {
        const hasFailure = responses.some(response => response.success === false);

        if (hasFailure) {
          console.warn('ERRO:', responses);
          // Optionally handle the failure here
          return;
        }

        this.getAssociationresult(responses, requests, folderName);

      },
      (error) => {
        console.error('Error fetching estimates:', error);
      }
    )
  }

  isProjectOwner() {
    return this.userId === this.project.owner
  }


  getStateText(level: string): string {
    switch (level) {
      case this.estimationState.COMPLETE:
        return this.variables.finished;
      case this.estimationState.INCOMPLETE:
        return this.variables.onGoing;
      case this.estimationState.CERTIFIED:
        return this.variables.certified;
      case this.estimationState.APPROVED:
        return this.variables.approved;
      case this.estimationState.REJECTED:
        return this.variables.rejected;
      case this.estimationState.TO_FIX:
        return this.variables.toFix;
      case this.estimationState.CLOSED:
        return this.variables.Closed;
      default:
        return '';
    }
  }

  canCheckEstimate(element: any) {
    return element.state !== this.estimationState.INCOMPLETE;
  }

  canCheckEstimateMessage(element: any) {
    if (element.state === this.estimationState.INCOMPLETE) {
      return this.variables.messageViewEstimateErrorIncomplete;
    }
    return this.variables.result;
  }

  //edit button actions
  canEditEstimate(estimate: any): boolean {
    return estimate.state === this.estimationState.COMPLETE || estimate.state === this.estimationState.INCOMPLETE || estimate.state === this.estimationState.TO_FIX;
  }

  canEditEstimateMessage(estimate: any): string {
    if (!this.canEditEstimate(estimate)) {
      return this.variables.messageEditEstimateErrorCertified;
    }
    else {
      return this.variables.edit;
    }
  }

  editEstimate(element: any) {
    if (this.canEditEstimate(element)) {
      //this.service.setEstimativaNavigationContext({
      //  clickedItem: element
      //});
      this.service.setEstimativaNavigationContext({ origin: "combinedResultPage" }); //Set the setEstimativaNavigationContext.
      this.service.setEstimate(element.id);
      this.router.navigate(['/estimativa', { state: { estimateState: element.state } }]);
    }
    else {
      return;
    }
  }

  //delete button actions 
  deleteEstimate(element: any) {

    if (!this.canDeleteEstimate(element)) {
      return;
    }

    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {

        this.estimateService.deleteEstimate(element.id).subscribe({
          next: (data) => {
            if (data.success) {
              this.infoBar.showSnackbar(this.variables.itemDeleted, ['successful-snackbar'], 3000);
              this.refreshAfterDelete(element.id);
            }
          },
          error: (error) => {
            console.error('Error:', error.error);
            this.infoBar.showSnackbar(this.variables.unknownError, ['error-snackbar'], 3000);
          }
        });
      }
    })
  }

  canDeleteEstimate(element: any): boolean {
    return element.state === this.estimationState.INCOMPLETE;
  }

  canDeleteEstimateMessage(element: any): string {
    if (!this.canDeleteEstimate(element)) {
      return this.variables.messageDeleteEstimateErrorNotIncomplete;
    }
    return this.variables.remove;
  }

  refreshAfterDelete(deletedEstimateId: string): void {
    // Remove the estimate from the local data
    const currentData = this.notAssociatedEstimates.data as any[];
    const updatedData = currentData.filter(estimate => estimate.id !== deletedEstimateId);
    this.notAssociatedEstimates.data = updatedData;

    // Update paginator if we deleted the last item on a page (and not on the first page)
    if (this.paginator1) {
      const currentPageItemCount = updatedData.length % this.paginator1.pageSize;
      const currentPageIndex = this.paginator1.pageIndex;

      if (currentPageItemCount === 0 && currentPageIndex > 0 && updatedData.length > 0) {
        this.paginator1.pageIndex = currentPageIndex - 1;
      }

      this.paginator1.length = updatedData.length;
    }

    this.cdr.detectChanges();
  }
}
